import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import { ToastContainer } from 'react-toastify';
import { useAuth0 } from '@auth0/auth0-react';
import { Menu } from './Menu/Menu';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Session } from './session/Session';
import { SessionSummary } from './SessionSummary/sessionSummary';
import { useAppDispatch } from './store/hooks';
import { setJwtToken } from './store/auth/authSlice';
import { QrScanner } from './qrScanner/QrScanner';

const audience = process.env.REACT_APP_AUTH0_AUDIENCE!;

const App = (): React.JSX.Element => {
	const dispatch = useAppDispatch();
	const { getAccessTokenSilently, isAuthenticated, isLoading: isAuth0Loading } = useAuth0();
	const [isLoadingApp, setIsLoadingApp] = React.useState(true);

	useEffect(() => {
		if (isAuthenticated && !isAuth0Loading) {
			getAccessTokenSilently({
				authorizationParams: { audience, scope: 'openid profile email' },
			})
				.then((token) => {
					// console.log('Got access token silently', token);
					dispatch(setJwtToken({ jwtToken: token }));
				})
				.catch((err) => {
					console.error('Error getting access token silently', err);
				})
				.finally(() => {
					setIsLoadingApp(false);
				});
		} else if (!isAuthenticated && !isAuth0Loading) {
			// Not authenticated, clear any existing token
			dispatch(setJwtToken({ jwtToken: null }));
			setIsLoadingApp(false);
		}
	}, [dispatch, getAccessTokenSilently, isAuthenticated, isAuth0Loading]);

	if (isLoadingApp) {
		return <div>Loading...</div>;
	}

	return (
		<div className="App">
			<ToastContainer
				position="bottom-center"
				autoClose={3000}
				hideProgressBar={false}
				className="toast-container-fullwidth"
				newestOnTop
				closeOnClick
				pauseOnHover
			/>
			<Routes>
				<Route path="/" element={<QrScanner />} />
				<Route path="session" element={<Session />}>
					<Route path="summary" element={<SessionSummary />} />
					<Route path="menu" element={<Menu />} />
				</Route>
				<Route path="*" element={<div>404</div>} />
			</Routes>
		</div>
	);
};

export default App;
